import React from "react";
import { NavLink } from "react-router-dom";

const SideNav = () => {
  return (
    <aside className="sidenav">
      <div className="sidenav-brand">
        <img
          src="/icons/Logo_PNG.png"
          alt="CatchClicker"
          className="sidenav-logo"
        />
        <div className="sidenav-title">Dashboard</div>
      </div>

      <nav className="sidenav-links">
        <div className="sidenav-group">
          <div className="sidenav-group-title">History</div>
          <NavLink to="/individual">Individual</NavLink>
          <NavLink to="/teams">Teams</NavLink>
        </div>

        <div className="sidenav-group sidenav-group-secondary">
          <a
            href="https://catchclicker.com/pages/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Account and agreement
          </a>
          <a
            href="https://catchclicker.com/pages/contact"
            target="_blank"
            rel="noreferrer"
          >
            FAQ & Support
          </a>
          <a href="https://catchclicker.com/" target="_blank" rel="noreferrer">
            Shop Now
          </a>
        </div>
      </nav>
    </aside>
  );
};

export default SideNav;
